import { useEffect, useState } from 'react'

import { useMe } from '@/api/hooks'

import { ReleaseNotesDialog } from './ReleaseNotesDialog'
import { APP_RELEASE, hasSeenRelease, markReleaseSeen, releaseStorageKey } from './releaseState'

function AccountAnnouncement({ userId }: { userId: number }) {
  const key = releaseStorageKey(userId, APP_RELEASE.version)
  const [open, setOpen] = useState(() => !hasSeenRelease(key))

  useEffect(() => {
    function onStorage(event: StorageEvent) {
      if (event.key === key && event.newValue === '1') setOpen(false)
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [key])

  function onOpenChange(next: boolean) {
    if (!next) markReleaseSeen(key)
    setOpen(next)
  }

  return <ReleaseNotesDialog open={open} onOpenChange={onOpenChange} />
}

/** Mount only after sign-in, keyed so switching accounts checks their own seen state. */
export function ReleaseAnnouncement() {
  const { data: user } = useMe()
  return user ? <AccountAnnouncement key={user.id} userId={user.id} /> : null
}
